import { render, staticRenderFns } from "./ListMagang.vue?vue&type=template&id=162fbdae&scoped=true"
import script from "./ListMagang.vue?vue&type=script&lang=js"
export * from "./ListMagang.vue?vue&type=script&lang=js"
import style0 from "./ListMagang.vue?vue&type=style&index=0&id=162fbdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162fbdae",
  null
  
)

export default component.exports